import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { UkAccessGuard } from './guards/uk-access.guard';

const routes: Routes = [
	{
		path: '',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent)
	},
	{
		path: 'question-form',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/question-form/question-form.component').then(m => m.QuestionFormComponent)
	},
	{
		path: 'submission',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/submission/submission.component').then(m => m.SubmissionComponent)
	},
	{
		path: 'submission-confirmation',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/submission-confirmation/submission-confirmation.component').then(m => m.SubmissionConfirmationComponent)
	},
	{
		path: 'submission-results/:uuid',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/submission-results/submission-results.component').then(m => m.SubmissionResultsComponent)
	},
	{
		path: 'faqs',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/faqs/faqs.component').then(m => m.FaqsComponent)
	},
	{
		path: 'privacy-policy',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
	},
	{
		path: 'sponsors',
		canActivate: [UkAccessGuard],
		loadComponent: () => import('./pages/sponsors/sponsors.component').then(m => m.SponsorsComponent)
	},
	{
		path: '',
		redirectTo: '',
		pathMatch: 'full'
	},
	{
		path: '**',
		redirectTo: ''
	},
];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }
